<template>
    <v-error-messages
        :has-frontend-errors="this.validate.$error"
        :server-error="serverError"
        title="Bump Offer Errors"
        class="stack-l">
        <template v-if="lines.length">
            <ul class="list" :class="{'stack-m': index !== lines.length - 1}" v-for="(offer, index) in lines">
                <li>{{offer.name}}</li>
                <li class="list-item" v-for="error in offer.results">{{error}}</li>
            </ul>
        </template>
    </v-error-messages>
</template>

<script>
    import {vErrorMessages} from '@/components/form';
    import _ from '@/common/helpers';

    export default {
        name: 'error-messages',
        components: {vErrorMessages},
        props: {
            serverError: Error,
            offers: Array,
            validate: Object,
        },
        computed: {
            lines() {
                if (!this.validate.$dirty) {
                    return [];
                }
                const reducer = (acc, offer, currentIndex) => {
                    const rules = this.validate.$each.$iter[currentIndex];
                    if (rules.$invalid) {
                        const results = [
                            ...this.getAmountRules(rules, 'bumpAmount'),
                            ...this.getAmountRules(rules, 'bonusAmount'),
                            [rules.choices.$error, `You must provide content for all languages`],
                            [!rules.weight.between, `The version's weight must be between zero (0) and one hundred (100) inclusively.`],
                        ].reduce((combined, [predicate, message]) => {
                            if (predicate) {
                                combined.push(message);
                            }
                            return combined;
                        }, []);
                        const line = {
                            name: this.offers[currentIndex].name,
                            results,
                        };
                        acc.push(line);
                    }
                    return acc;
                };
                return Object.keys(this.validate.$each.$iter).reduce(reducer, []);
            },
        },
        methods: {
            getAmountRules(rules, target) {
                const name = _.unCamelCase(target);
                return [
                    [!rules[target].isAmount, `The ${name} must be numerical`],
                    [!rules[target].required, `The ${name} is required`],
                    [!rules[target].minValue, `The ${name} must be greater than 0.00`],
                ];
            },
        },
    };
</script>

<style scoped>

</style>
